import clsx from 'clsx'
import { DetailedHTMLProps, forwardRef, TextareaHTMLAttributes } from 'react'
import { Icon, IconName } from './Icon'
import styles from './TextArea.module.sass'

export type TextAreaProps = Pick<
	DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>,
	| 'name'
	| 'autoComplete'
	| 'value'
	| 'onChange'
	| 'disabled'
	| 'readOnly'
	| 'placeholder'
	| 'required'
> & {
	iconDecoration?: IconName
	noBorder?: boolean
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
	(
		{
			name,
			autoComplete,
			value,
			onChange,
			disabled,
			readOnly,
			placeholder,
			required,
			iconDecoration,
			noBorder,
		},
		ref
	) => {
		return (
			<div
				className={clsx(
					styles.wrapper,
					iconDecoration && styles.is_iconDecoration,
					noBorder && styles.noBorder
				)}>
				<textarea
					className={styles.input}
					name={name}
					autoComplete={autoComplete}
					readOnly={readOnly}
					placeholder={placeholder}
					value={value}
					onChange={onChange}
					disabled={disabled}
					required={required}
					ref={ref}
				/>
				{iconDecoration && (
					<span className={styles.icon}>
						<Icon name={iconDecoration} />
					</span>
				)}
			</div>
		)
	}
)

TextArea.displayName = 'TextArea'
